import AnswerOverviewAPI from '@/apis/business/student/answer-overview-api.js'
import { formatText } from '@/utils/text'
import Enumeration from '@/common/enumeration.js'
import { handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'

export default {
  namespaced: true,
  state: {
    dataAnswerOverview: {}
  },
  mutations: {

    setDataAnswerOverview (state, dataAnswer) {
      if (dataAnswer.ParentQuestions?.length > 0) {
        dataAnswer.ParentQuestions?.forEach(item => {
          const groupQuestion = dataAnswer.Questions.filter(question => question.ParentID === item.SortOrder)
          if (groupQuestion.length > 0) {
            const startIndex = groupQuestion[0].SortOrder
            const endIndex = groupQuestion[groupQuestion.length - 1].SortOrder

            let numberQuestion = formatText(startIndex, 2, '0')
            if (endIndex && startIndex !== endIndex) {
              numberQuestion = `${numberQuestion} - ${formatText(endIndex, 2, '0')}`
            }
            item.ParentName = numberQuestion
          }
        })
        dataAnswer.Questions.forEach(function (question) {
          let ParentQuestion = null
          if (question.ParentID) {
            ParentQuestion = dataAnswer.ParentQuestions.find(item => item.SortOrder === question.ParentID)
          }
          question.ParentQuestion = ParentQuestion
        })
      }
      state.dataAnswerOverview = dataAnswer
    }
  },
  actions: {
    getAnswerOverview (context, params) {
      return new Promise((resolve, reject) => {
        AnswerOverviewAPI.getAsync(`preview-submit-exercise?studentExerciseID=${params.StudentExerciseID}&submitExercisesID=${params.SubmitExerciserID}`)
          .then(res => {
            const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)

            context.commit('setDataAnswerOverview', exercise)
            resolve(res.Data)
          }).catch(err => {
            reject(err)
          })
      })
    }
  }
}
